import config, { ISetupData } from './config';
import user, { IUserData } from './user';


interface ICtxData {
    isReady: boolean;
    isSetupCompleted: boolean;
    isUserAuthenticated: boolean;
    user: IUserData;
    config: ISetupData;
}

interface ICtx {
    get(): Promise<ICtxData>;
    getReady(): Promise<boolean>;
}

class Ctx {

    private t: any;

    constructor(t?: any) {
        this.t = t;
    }

    public using(t: any) : ICtx {
        return new Ctx(t);
    }

    public get(): Promise<ICtxData> {
        var self = this;
        return new Promise(resolve => {

            var p1 = config(self.t).get();
            var p2 = user(self.t).getUserData();

            Promise.all([p1,p2]).then(args => {
                var ctxData: ICtxData = {
                    isReady: false,
                    isSetupCompleted: false,
                    isUserAuthenticated: false,
                    config: <any>{},
                    user: <any>{}
                }
                ctxData.isSetupCompleted = args[0].isCompleted;
                if (args[1] && args[1].stobApiToken) {
                    ctxData.isUserAuthenticated = true;
                }
                if (ctxData.isSetupCompleted && ctxData.isUserAuthenticated) {
                    ctxData.isReady = true;
                }
                ctxData.config = args[0];

                ctxData.config.isShowAnnotationsOnCardBack =
                    ctxData.config.isShowAnnotations && ctxData.config.isShowAnnotationsOnCardBack;
                ctxData.config.isShowAnnotationsOnCardFront =
                    ctxData.config.isShowAnnotations && ctxData.config.isShowAnnotationsOnCardFront;

                ctxData.config.isShowCardContextGoalOnCardFront =
                    ctxData.config.isShowCardContext && ctxData.config.isShowCardContextGoalOnCardFront;
                ctxData.config.isShowCardContextStepOnCardFront =
                    ctxData.config.isShowCardContext && ctxData.config.isShowCardContextStepOnCardFront;
                ctxData.config.isShowCardContextOnCardBack =
                    ctxData.config.isShowCardContext && ctxData.config.isShowCardContextOnCardBack;

                ctxData.config.isShowEstimationOnCardBack =
                    ctxData.config.isShowEstimation && ctxData.config.isShowEstimationOnCardBack;
                ctxData.config.isShowEstimationOnCardFront =
                    ctxData.config.isShowEstimation && ctxData.config.isShowEstimationOnCardFront;

                ctxData.config.isShowReleasesOnCardBack =
                    ctxData.config.isShowReleases && ctxData.config.isShowReleasesOnCardBack;
                ctxData.config.isShowReleasesOnCardFront =
                    ctxData.config.isShowReleases && ctxData.config.isShowReleasesOnCardFront;

                ctxData.user = args[1];
                resolve(ctxData);
            })
        });
    }

    public getReady(): Promise<boolean> {
        var self = this;
        return new Promise(resolve => {
            self.get().then(d => {
                resolve(d.isReady);
            })
        });
    }
}

export var ctx = function(t: any): ICtx { return new Ctx().using(t); }
export default ctx;
